module.exports = __webpack_public_path__ + "static/img/cchj1.a7722662.png";